'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _lodash = require('lodash');

var _dateConstants = require('../common/dateConstants');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var RangePicker = _next.DatePicker.RangePicker;
var CascadeDate = (_temp = _class = function (_Field) {
  _inherits(CascadeDate, _Field);

  function CascadeDate(props) {
    _classCallCheck(this, CascadeDate);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.disabledDate = function (date) {
      var timeStamp = date.valueOf();
      var _this$props$selectabl = _this.props.selectable;
      _this$props$selectabl = _this$props$selectabl === undefined ? {} : _this$props$selectabl;
      var from = _this$props$selectabl.from,
          to = _this$props$selectabl.to;

      if (from && to) {
        return timeStamp < from - 24 * 60 * 60 * 1000 || timeStamp > to;
      } else if (from) {
        return timeStamp < from - 24 * 60 * 60 * 1000;
      } else if (to) {
        timeStamp > to;
      }
      return false;
    };

    _this.onVisibleChange = _this.onVisibleChange.bind(_this);
    _this.handleMmddFunc = _this.handleMmddFunc.bind(_this);
    _this.handleDdFunc = _this.handleDdFunc.bind(_this);
    _this.watchClick = _this.watchClick.bind(_this);
    return _this;
  }

  CascadeDate.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-cascade-date'
    });
  };

  CascadeDate.prototype.watchClick = function watchClick() {
    var btnDoms = document.getElementsByClassName('next-calendar-btn');
    setTimeout(function () {
      if (btnDoms[2].title === '一月') {
        btnDoms[1].style.display = 'none';
      } else if (btnDoms[4].title === '十二月') {
        btnDoms[6].style.display = 'none';
      } else {
        btnDoms[1].style.display = 'inline-block';
        btnDoms[6].style.display = 'inline-block';
      }
    }, 0);
  };

  CascadeDate.prototype.handleMmddFunc = function handleMmddFunc(visible) {
    var btnDoms = document.getElementsByClassName('next-calendar-btn');
    console.log('btnDoms', btnDoms);
    var headerDom = document.getElementsByClassName('next-calendar-panel-header');
    btnDoms[0].style.display = 'none';
    btnDoms[3].style.display = 'none';
    btnDoms[5].style.display = 'none';
    btnDoms[7].style.display = 'none';
    if (visible) {
      this.watchClick();
      headerDom[0].addEventListener('click', this.watchClick);
    } else {
      headerDom[0].removeEventListener('click', this.watchClick);
    }
  };

  CascadeDate.prototype.handleDdFunc = function handleDdFunc() {
    var headDom = document.getElementsByClassName('next-calendar-panel-header');
    headDom[0].style.display = 'none';
    var rightDom = document.getElementsByClassName('next-calendar-body-right');
    rightDom[0].style.display = 'none';
    var prevDoms = document.getElementsByClassName('next-calendar-cell-prev-month');
    var nextDoms = document.getElementsByClassName('next-calendar-cell-next-month');
    [].concat(_toConsumableArray(prevDoms), _toConsumableArray(nextDoms)).forEach(function (item) {
      item.style['pointer-events'] = 'none';
      var innerDom = item.getElementsByClassName('next-calendar-date');
      innerDom[0].style['pointer-events'] = 'none';
      innerDom[0].style.color = 'transparent';
    });

    var bodyDom = document.getElementsByClassName('next-calendar-body');
    bodyDom[0].style.display = 'flex';
    bodyDom[0].style['justify-content'] = 'center';
  };

  CascadeDate.prototype.onVisibleChange = function onVisibleChange(visible) {
    var _this2 = this;

    setTimeout(function () {
      var _props = _this2.props,
          format = _props.format,
          dateType = _props.dateType;

      var realFormat = format || dateType;
      var lowerCaseFormat = realFormat.toLocaleLowerCase();
      console.log('lowerCaseFormat', lowerCaseFormat);
      if (lowerCaseFormat === 'mm-dd') {
        _this2.handleMmddFunc(visible);
      } else if (lowerCaseFormat === 'dd') {
        _this2.handleDdFunc();
      }
    }, 0);
  };

  CascadeDate.prototype.renderControl = function renderControl() {
    var commonProps = this.getControlProps();

    var _props2 = this.props,
        format = _props2.format,
        dateType = _props2.dateType,
        autoWidth = _props2.autoWidth,
        _props2$placeholder = _props2.placeholder,
        placeholder = _props2$placeholder === undefined ? {} : _props2$placeholder;

    var realFormat = format || dateType;

    var fieldProps = _extends({}, commonProps, {
      style: _extends({}, commonProps.style, { width: '100%' }),
      type: this.type,
      autoWidth: autoWidth,
      format: _dateConstants.TRANSFORM_FORMAT[realFormat] || realFormat,
      placeholder: [placeholder.start || '开始日期', placeholder.end || '结束日期'],
      showTime: this.showTime,
      disabledDate: this.disabledDate,
      ranges: this.ranges
    });

    return _react2.default.createElement(RangePicker, _extends({}, fieldProps, { onVisibleChange: this.onVisibleChange }));
  };

  _createClass(CascadeDate, [{
    key: 'type',
    get: function get() {
      var _props3 = this.props,
          format = _props3.format,
          dateType = _props3.dateType;

      var realFormat = format || dateType;
      switch (realFormat) {
        case 'yyyy-MM':
          return 'month';
        case 'YYYY':
          return 'year';
        default:
          return 'date';
      }
    }
  }, {
    key: 'showTime',
    get: function get() {
      var _props4 = this.props,
          format = _props4.format,
          dateType = _props4.dateType;

      var realFormat = format || dateType;
      if (realFormat === 'yyyy-MM-dd HH:mm') {
        return { format: 'HH:mm' };
      } else if (realFormat === 'yyyy-MM-dd HH:mm:ss') {
        return { format: 'HH:mm:ss' };
      } else {
        return null;
      }
    }
  }, {
    key: 'ranges',
    get: function get() {
      var quickSelectRanges = this.props.quickSelectRanges;

      if ((0, _lodash.isEmpty)(quickSelectRanges)) {
        return {};
      }
      var ranges = {};
      // 当天零点的时间
      var current = (0, _moment2.default)().valueOf();
      quickSelectRanges.forEach(function (item) {
        var type = item.type,
            text = item.text;
        var start = item.start,
            end = item.end;

        switch (type) {
          case 'today':
            start = (0, _moment2.default)().startOf('day').valueOf();
            end = current;
            break;
          case 'yesterday':
            start = (0, _moment2.default)().startOf('day').subtract(1, 'days').valueOf();
            end = (0, _moment2.default)().startOf('day').valueOf() - 1;
            break;
          case 'week':
            start = (0, _moment2.default)().startOf('week').valueOf();
            end = current;
            break;
          case 'month':
            start = (0, _moment2.default)().startOf('month').valueOf();
            end = current;
            break;
          case 'year':
            start = (0, _moment2.default)().startOf('year').valueOf();
            end = current;
            break;
          default:
            break;
        }
        ranges[text] = [start, end];
      });
      return ranges;
    }
  }]);

  return CascadeDate;
}(_vuFusionField2.default), _class.displayName = 'CascadeDate', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  hasClear: true,
  autoWidth: true
}), _class.validators = {
  required: {
    valid: function valid(value) {
      return value && value.startDate && value.endDate;
    },
    defaultMessage: {
      en_US: '%s cannot be empty',
      zh_CN: '%s不能为空'
    }
  }
}, _class.defaultMutators = _vuFusionField2.default.defaultMutators, _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['dateType', 'format']), _temp);
exports.default = CascadeDate;
module.exports = exports['default'];